import React, { useLayoutEffect } from 'react'
import Footer from '../Component/Footer/Footer'
import FooterNav from '../Component/AppComponent/Footer/FooterNav'

const Shipping = () => {
    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });
    return (
        <div>
            <div className='Terms-and-conditions-page'>
                <div className='container'>
                    <div className='Terms-and-conditions-page'>
                        <h2>Shipping Information</h2>

                        <h3>Fast & Reliable Delivery</h3>
                        <p>We are committed to ensuring your order reaches you as quickly and safely as possible. Once your order has been successfully placed and verified, it is processed within 72 hours during regular business days (Monday to Friday).</p>
                        <p>Once dispatched, the expected delivery time is typically between 2 to 7 business days. Please note that during public holidays or peak periods such as promotional launches, delivery times may be slightly extended.</p>
                        <p>Shipping operations are carried out only on working weekdays, and you will be shown an estimated delivery timeline during the checkout process.</p>
                        <p>After your package has been handed over to the shipping partner, you will receive a confirmation email from us—usually within 1 to 3 business days. This email will include a tracking number, allowing you to monitor the status of your shipment.</p>

                        <h3>International Orders & Customs</h3>
                        <p>For international deliveries, please be aware that customs duties, import taxes, and other applicable charges may be levied by the destination country. These charges are the full responsibility of the customer and are not included in the product or shipping prices.</p>
                        <p>If the recipient refuses to accept the package due to unpaid customs fees, the order will not qualify for a refund. We are also not responsible for customs delays or any issues resulting from incorrect shipping details provided at the time of purchase.</p>
                        <p>Tracking details will typically be shared 1 to 2 business days after your order has been placed.</p>

                        <h3>Lost or Stolen Shipments</h3>
                        <p>We are not responsible for any parcels that go missing, are misplaced, or are stolen after being marked as delivered to the correct address provided during checkout.</p>
                        <p>For any concerns regarding your shipment, feel free to contact our support team. We’ll do our best to assist you.</p>
                    </div>
                </div>
            </div>

            <Footer />
            <FooterNav />
        </div>
    )
}

export default Shipping
